'use client';

import { useEffect } from 'react';

export function useSidebarFix() {
  useEffect(() => {
    // Cleanup duplicate sidebars after render
    const cleanupDuplicateSidebars = () => {
      const sidebars = document.querySelectorAll('.sidebar');
      if (sidebars.length > 1) {
        // console.warn(`[SidebarFix] Found ${sidebars.length} sidebars, removing duplicates...`);
        // Keep only the first sidebar
        for (let i = 1; i < sidebars.length; i++) {
          sidebars[i].remove();
        }
      }
    };

    // Run cleanup after a short delay to ensure DOM is ready
    const timer = setTimeout(cleanupDuplicateSidebars, 100);

    // Also run on mutation to catch dynamic duplicates
    const observer = new MutationObserver(() => {
      cleanupDuplicateSidebars();
    });

    observer.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, []);
}